import React, { Component } from 'react';
import { getClass } from '../../../../utils/component-helpers';
import { session } from 'services/session';
import Constants from '../../../../app.constants';

class NavItem extends Component {
	constructor(props) {
		super(props);

		this.state = {
			hover: false,
		};
	}

	hover() {
		this.setState((state) => ({
			hover: !state.hover,
		}));
	}

	isSelected(path) {
		const currentPath = this.props.currentPath;
		const itemPath = this.props.item.path;
		if (path) {
			return currentPath.endsWith(path); // subnavItem path
		} else {
			// On megatable under Insights subnav ie not on merchants table
			const notMerchTable = !currentPath.endsWith('/merchants') && currentPath.indexOf(itemPath) > -1;
			return currentPath.endsWith(itemPath) || notMerchTable;
		}
	}

	subnavCollapsed() {
		return this.props.item.subnav && !this.props.item.subnavExpanded;
	}

	subnavExpanded() {
		if (!this.props.item.subnav) return false;
		return this.props.item.subnavExpanded;
	}

	render() {
		const item = this.props.item;
		const className = item.className || item.path.replace('/', '');
		let icon, subnav;
		const isStagingPubTestUser = session.userId === 233638 && ['staging', 'local'].includes(Constants.ENV);
		const isReleasePubTestUser = [2458, 2464].includes(session.userId) && ['release'].includes(Constants.ENV);
		const isPubTestUser = isStagingPubTestUser || isReleasePubTestUser;

		if (item.subnav) {
			subnav = (
				<ul className="subnav">
					{item.subnav
						// Exclude navItems when viewing allSites
						.filter((item) => !(session.allSites && item.hiddenForAllSites))
						// Exclude navItems under feature toggle
						.filter((item) => {
							return (isPubTestUser && ['/product-research'].includes(item.path)) || session.isAdminView
								? true
								: !item.featureToggle;
						})
						.map((subnavItem, index) => {
							const dataPath = subnavItem.path === '/bam-box'
								? subnavItem.path
								: `${item.path}${subnavItem.path}`;
							const subnavClass = subnavItem.path.replace('/', '');
							return (
								<li
									className={getClass(`subnav-item ${subnavClass}`, {
										'selected': this.isSelected(subnavItem.path),
									})}
									key={index}
									data-path={dataPath}
									onClick={this.props.onSubnavItemClicked}>
									<div className="subnav-item-label">
										{subnavItem.label}
									</div>
								</li>
							);
						})}
				</ul>
			);
		}

		return (
			<li
				className={getClass(`nav-item ${className}`, {
					'hover': this.state.hover,
					'expanded': this.subnavExpanded(),
					'collapsed': this.subnavCollapsed(),
					'selected': this.isSelected(),
					'no-subnav': !item.subnav,
				})}
				/* Bubble event up to be handled by NavSidebar */
				onClick={this.props.onNavItemClicked}>
				<span className="label"
					onMouseEnter={this.hover.bind(this)}
					onMouseLeave={this.hover.bind(this)}>
					{item.label}
				</span>
				{subnav}
			</li>
		);
	}
}

export default NavItem;
